<fury-page-layout>
    <fury-page-layout-content @fadeInUp>
        <fury-container>
            <h1>Selecteer het type melding</h1>
            <div class="form-selection-container">
                <div class="form-type" routerLink="/klacht-overlast">
                    <mat-icon>announcement</mat-icon>
                    <span>Klacht</span>
                </div>
                <div class="form-type" routerLink="/bedrijfsmelding">
                    <mat-icon>account_balance</mat-icon>
                    <span>Bedrijfsmelding</span>
                </div>
            </div>
        </fury-container>
    </fury-page-layout-content>
</fury-page-layout>
